import {
  SAVE_TO_SHORTLIST,
  RECEIVE_SHORTLIST_RESPONSE,
  RECEIVE_LATEST_SHORTLIST_DATA,
  INIT_SHORTLIST,
} from "./actionTypes";
import { modalTypes } from "./modalTypes";

const initialState = {
  isLoading: false,
  modalTypeId: null,
  vehicleId: null,
  shortlist: [],
};

export const shortlist = (state = initialState, action) => {

  if (action.type === SAVE_TO_SHORTLIST) {
    const { vehicleId } = action.payload;
    return {
      ...state,
      vehicleId,
      isLoading: true,
      modalTypeId: null,
    };
  } else if (action.type === RECEIVE_SHORTLIST_RESPONSE) {
     const { modalTypeId, vehicleId, calculationParameters } = action.payload;
    const shortlist =
      modalTypeId === modalTypes.SUCCESS
        ? [...state.shortlist, { vehicleId, calculationParameters }]
        : [...state.shortlist];
    return {
      ...state,
      modalTypeId,
      shortlist,
      isLoading: false,
      vehicleId: null,
    };
  } else if (action.type === RECEIVE_LATEST_SHORTLIST_DATA) {
    const shortlist = action.payload.shortlist;
    window.sessionStorage.setItem("refreshShortlist", false);
    return {
      ...state,
      shortlist,
    };
  } else if (action.type === INIT_SHORTLIST) {
    return {
      ...state,
      modalTypeId: null,
      isLoading: false,
    };
  }
  return state;
};
